import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes } from '../../../components/foundations/Icon';
import CodeBlock from '../../../components/organisms/CodeBlock/CodeBlock';
import ArtifactLoader from './ArtifactLoader';
import css from './CodeArtifact.css';

const CodeArtifactInner = ({ data }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const language = 'python';
    const codeString =
        typeof data === 'string' ? data : data?.code || JSON.stringify(data, null, 2);

    const toggleCollapse = () => setIsCollapsed(!isCollapsed);

    return (
        <div className={css.codeArtifact}>
            <div className={css.header} onClick={toggleCollapse}>
                <Icon
                    name={isCollapsed ? 'chevron-right' : 'chevron-down'}
                    size={IconSizes.SMALL}
                    className={css.collapseIcon}
                />
                <Icon name="code" size={IconSizes.SMALL} />
                <span>Generated Code</span>
            </div>
            {!isCollapsed && (
                <CodeBlock
                    initialCode={codeString || 'No code content available'}
                    codeLanguage={language}
                    showHeader
                    showLineNumbers
                    darkTheme
                    codeClassName={css.codeBlock}
                />
            )}
        </div>
    );
};

const CodeArtifact = ({ artifact }) => (
    <ArtifactLoader artifact={artifact}>
        {data => <CodeArtifactInner data={data} />}
    </ArtifactLoader>
);

CodeArtifact.propTypes = {
    artifact: PropTypes.shape({
        data: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
                type: PropTypes.string,
                code: PropTypes.string,
            }),
        ]),
        content_url: PropTypes.string,
    }).isRequired,
};

export default CodeArtifact;
